import React from 'react';
import reportRegimeHelper from '../../infrastructure/helpers/report/reportRegime/reportRegimeHelper';

const email = 'controlbox@control-now.com';

class Home extends React.Component<any, { regimes: string[] }> {
    
    render(): JSX.Element {
        return (
            <>
                <div style={{ height: '74px', width: '100%' }}>
                    <img src="/logo-cb.png" alt="logo-cb" />
                </div>

                <p>Control Box can be used to design and build transaction reports. The solution includes the following modules;</p>

                <ol>
                    <li>Ingestion: Upload and configure raw data sets</li>
                    <li>Reporting: Design filtering and enrichment logic to convert raw data sets into MiFIR_RTS_22, EMIR, ASIC, MAS, SFTR, OSC, MiFIR_RTS_21, SIX_D, SIX_S, MiFIR_RTS_1_2, CAT and REMIT transaction reports.</li>
                </ol>

                <p>The solution includes the following functionality;</p>

                <ul>
                    <li>Lookups: Users can reference unlimited reference data sets to enrich raw system data to the necessary information required for reporting</li>
                    <li>Audit: All changes to reporting configs are logged and stored for audit</li>
                    <li>User and Compliance Guidance: Control Box is designed to include integrated compliance and user guidance.</li>
                    <li>Collaborative working: Multiple users can access and amend each reporting config.</li>
                    <li>Action Logs: Users can assign actions and monitor to completion.</li>
                    <li>Real time development and testing: Once configured, the source is immediately ready for business testing.</li>
                </ul>

                <p>For any support with accessing and using the Control Box functionality, please email <a href={`mailto:${email}`}>{email}</a></p>
            </>
        );
    }
}

export default Home;
